import { Pipe, PipeTransform } from "@angular/core";

import { LogicalPage, PdfOffset, PhysicalPage } from "src/core/backend/controllers";
import { isNotNull } from "src/shared/utils";

@Pipe({ name: "firstDefined" })
export class FirstDefinedPipe implements PipeTransform {
  transform<T extends number>(args: Array<T | undefined>): T | undefined {
    return args.find(isNotNull);
  }
}

export function physicalToLogicalPage(page: PhysicalPage | undefined | null, pdfOffset: PdfOffset | undefined | null): LogicalPage {
  return ((page ?? 1) + ((pdfOffset ?? 1) - 1)) as LogicalPage;
}

export function logicalToPhysicalPage(page: LogicalPage | undefined | null, pdfOffset: PdfOffset | undefined | null): PhysicalPage {
  return ((page ?? 1) - ((pdfOffset ?? 1) - 1)) as PhysicalPage;
}
